module.exports = __webpack_public_path__ + "img/eco-positive-with-symptons.cdb00598.png";